export default "__VITE_ASSET__b01VH2Z8__"